import type { ViteSSGContext } from 'vite-ssg'

export type UserModule = (ctx: ViteSSGContext) => void

export namespace ECM {
  export enum Locale {
    EN = 'en',
    FR = 'fr',
    ES = 'es',
  }
}
